import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './ui/gateways/request-http-interceptor';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { registerLocaleData } from "@angular/common";
import localePt from "@angular/common/locales/pt";

import { AppComponent } from "./app.component";
import { ContextModule } from "./ui/contexts/context.module";
import { AppRoutingModule } from "./ui/routing/routing.module";
import { ServiceModule } from "./ui/services/service.module";
import { CoreModule } from "./core/core.module";
import { ProviderModule } from "./ui/providers/providers.module";
import { ComponentModule } from "./ui/components/component.module";
import { ThemeService, provideCharts, withDefaultRegisterables } from "ng2-charts";
import { MatSortModule } from "@angular/material/sort";
import { ODataModule } from 'angular-odata';
import { environment } from 'src/environments/environment';

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ContextModule.forRoot(),
    ServiceModule.forRoot(),
    ProviderModule.forRoot(),
    ComponentModule,
    MatSortModule,
    ODataModule.forRoot({
      config: {
        serviceRootUrl: environment.idpNetworkUrl + 'api/v1'
      },
    }),
  ],
  providers: [
    ThemeService,
    provideCharts(withDefaultRegisterables()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

